import { useReduxState } from 'hooks';
import { MoreOptions } from 'components/common';
import { DropdownButton } from 'components/common/dropdown';
import { ReviewDelete } from '.';

const ReviewDropdown = ({ courseId, onDataChange, onEdit, review }) => {
  const { messages } = useReduxState();

  return (
    <MoreOptions styleContentButtons={false}>
      {onEdit ? (
        <DropdownButton
          icon="pen"
          onClick={onEdit}
          text={messages.commonEdit}
        />
      ) : null}
      <ReviewDelete
        courseId={courseId}
        onDataChange={onDataChange}
        review={review}
      />
    </MoreOptions>
  );
};

export default ReviewDropdown;
